module.exports = __webpack_public_path__ + "img/pacote-start-local.6668400e.jpg";